import React, {createContext, useEffect, useState} from 'react';
import {AuthResponse} from "../services/appointment-service"
import {useResizeListener} from "primereact/hooks";
import {Circles} from "react-preloaders2";

export const UserContext = createContext<any>(null);

export interface UserInfo extends AuthResponse{
    authenticated: boolean;
}

export const UserContextProvider = (props: any) => {
    const initialState : UserInfo = {
        id: 0,
        authenticated: false
    }

    const [userInfo, setUserInfo] = useState(initialState);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    const [bindWindowResizerListener, unbindWindowResizeListener] = useResizeListener({
        listener:(event: Event) => {
            // @ts-ignore
            setIsMobile(event.currentTarget.innerWidth < 992);
        }
    });



    useEffect(() => {
        bindWindowResizerListener();
        return () => {
            unbindWindowResizeListener();
        }
    }, [bindWindowResizerListener, unbindWindowResizeListener]);

    const updateUserInfo = (userInfo : Partial<UserInfo>) => {
        setUserInfo(prevState => {return {...prevState, ...userInfo}});

    }



    return <>
        <UserContext.Provider value={{userInfo, updateUserInfo, isMobile}}>
            {props.children}
        </UserContext.Provider>
    </>
};






